import { render, staticRenderFns } from "./list-item-default.vue?vue&type=template&id=370c812d"
import script from "./list-item-default.vue?vue&type=script&lang=js"
export * from "./list-item-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports